/**
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

"use strict";

import * as angular from "angular";

angular
  .module("tabsint.components.response-areas.qr", [])

  .controller("QrResponseAreaCtrl", function(
    $scope,
    $q,
    examLogic,
    page,
    results,
    notifications,
    logger,
    gettextCatalog,
    chaDosimeter,
    chaConstants,
    cha
  ) {
    // defaults
    page.dm.responseArea.scope = page.dm.responseArea.scope || "exam"; // default property for scope
    page.dm.responseArea.autoSubmit = angular.isDefined(page.dm.responseArea.autoSubmit)
      ? page.dm.responseArea.autoSubmit
      : true; // default property for autoSubmit
    page.dm.submitText = "Submit";
    // default autoConnectProperties
    if (angular.isDefined(page.dm.responseArea.autoConnectProperties)) {
      page.dm.responseArea.autoConnectProperties.connect = angular.isDefined(
        page.dm.responseArea.autoConnectProperties.connect
      )
        ? page.dm.responseArea.autoConnectProperties.connect
        : true;
      page.dm.responseArea.autoConnectProperties.deviceType = angular.isDefined(
        page.dm.responseArea.autoConnectProperties.deviceType
      )
        ? page.dm.responseArea.autoConnectProperties.deviceType
        : "None";
    }
    // backwards compatibility with `required`
    if (angular.isDefined(page.dm.responseArea.required)) {
      page.dm.responseArea.responseRequired = page.dm.responseArea.required;
    }

    // define initial submittable logic
    page.dm.isSubmittable = examLogic.getSubmittableLogic(page.dm.responseArea);

    var scanner;
    $scope.runningScan = false;
    try {
      scanner = cordova.plugins.barcodeScanner;
      $scope.qrCodeEnabled = true;
    } catch (err) {
      $scope.qrCodeEnabled = false;
      logger.error("Could not load barcode scanner: " + angular.toJson(err, true));
    }

    $scope.scanQrCode = function() {
      // check that QR code scanner is enabled
      if (!$scope.qrCodeEnabled) {
        logger.warn("QR Scanning not enabled");
        return;
      }
      $scope.runningScan = true;

      scanner.scan(
        function(result) {
          logger.debug("QR Scan: " + angular.toJson(result, true));

          $scope.$apply(function() {
            if (result.cancelled) {
              $scope.runningScan = false;
              return;
            }

            // attempt automatic device connection/disconnection when enabled
            let promise = $q.resolve();
            if (page.dm.responseArea.autoConnectProperties) {
              promise = $scope.changeDeviceConnection(result);
            }
            promise
              .then(function() {
                // make page submittable
                page.dm.isSubmittable = true;

                // show qrcode in view
                $scope.qrResults = result.text;

                // save page response
                page.result.response = result.text;

                // save on top level of exam result
                if (page.dm.responseArea.scope === "exam") {
                  results.current.qrString = result.text;
                }

                // auto-submit if enabled
                if (page.dm.responseArea.autoSubmit) {
                  examLogic.submit();
                }
              })
              .catch(function() {
                notifications.alert(
                  gettextCatalog.getString("TabSINT failed to scan QR Code with error: ") + angular.toJson(result, true)
                );
              })
              .finally(function() {
                $scope.runningScan = false;
              });
          });
        },
        function(result) {
          notifications.alert(
            gettextCatalog.getString("TabSINT failed to scan QR Code with error: ") + angular.toJson(result, true)
          );
          $scope.runningScan = false;
          $scope.digest();
        },
        {
          orientation: "landscape",
          formats: "QR_CODE, PDF_417, CODE_128", // default: all but PDF_417 and RSS_EXPANDED
          disableSuccessBeep: true
        }
      );
    };

    // handle connecting/disconnecting to the device scanned by the QR code
    $scope.changeDeviceConnection = function(result) {
      const deferred = $q.defer();
      const deviceName = result.text ? result.text : "";
      const connect = page.dm.responseArea.autoConnectProperties.connect;
      const duoDoseEnabled = page.dm.responseArea.autoConnectProperties.deviceType == "duodose";
      const isDuoDose = chaConstants.duoDoseWhitelistDeviceNames.some(keyword =>
        deviceName.toLowerCase().includes(keyword.toLowerCase())
      );
      if (duoDoseEnabled && isDuoDose) {
        const currentDeviceName = chaDosimeter.myCha ? chaDosimeter.myCha.name : chaDosimeter.myCha;
        if (connect) {
          if (deviceName != currentDeviceName) {
            return chaDosimeter.disconnect().then(function() {
              return chaDosimeter.connect(true, deviceName);
            });
          }
        } else if (deviceName == currentDeviceName) {
          return chaDosimeter.disconnect();
        }
        deferred.resolve();
        return deferred.promise;
      }
      deferred.reject();
      return deferred.promise;
    };
  });
